import React, {useEffect, useState} from 'react';
import {Button, SearchBar as AntSearchBar} from 'antd-mobile';
import {ScanningOutline} from 'antd-mobile-icons';
import {useBarCodeScanner} from 'components/BarCodeScanner';
import {isTrackingNumber} from "../../../../utils/BarCodeUtil";
import {playScanSound} from "../../../../utils/scanUtils";
import {useNetwork} from "../../../../hooks/useNetwork";
import {showNetworkErrorModal} from "../../../../components/NetworkErrorModal";
import {t} from "../../../../i18n";
import { useLocation } from 'react-router-dom';

interface SearchBarProps {
    onSearch: (value: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({onSearch}) => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const trackingNumberFromUrl = urlParams.get('trackingNumber');
    const fromParcelIdentification = urlParams.has('from') && urlParams.get('from') === 'parcel-identification';
    
    const [searchValue, setSearchValue] = useState('');
    const {isVisible, setIsVisible, scanResult} = useBarCodeScanner();
    const { isOnline } = useNetwork();

    // 只有从包裹识别页面跳转过来并且有trackingNumber参数时才自动搜索
    useEffect(() => {
        if (fromParcelIdentification && trackingNumberFromUrl) {
            setSearchValue(trackingNumberFromUrl);
            onSearch(trackingNumberFromUrl);
        }
    }, [fromParcelIdentification, trackingNumberFromUrl]);

    useEffect(() => {
        setIsVisible(false);
        // 清空扫码结果，避免从其他页面带过来的扫码结果
        const { setScanResult } = useBarCodeScanner.getState();
        setScanResult('');
        return () => {
            setIsVisible(true);
        };
    }, []);

    const handleSearch = (val: string) => {
        setSearchValue(val);
        onSearch(val);
    };

    const handleScan = () => {
        if (isOnline) {
            setIsVisible(!isVisible);
            return;
        }
        showNetworkErrorModal();
    };

    useEffect(() => {
        if (scanResult) {
            if (isTrackingNumber(scanResult)){
                playScanSound();
                handleSearch(scanResult);
            }
        }
    }, [scanResult]);

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center bg-white shadow-sm rounded-lg border-1 py-0">
                <div className="flex-1">
                    <AntSearchBar
                        placeholder={t('pages.delivery.delivering.searchContext')}
                        value={searchValue}
                        onChange={handleSearch}
                        style={{'--background': '#ffffff'}}
                    />
                </div>
                <div className="flex justify-center items-center">
                    <Button
                        onClick={handleScan}
                        fill="none"
                        size={"large"}
                    >
                        <ScanningOutline/>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SearchBar;